import { useEffect, useState } from 'react';
import { api, ApiError } from '../api';
import { readLinkHash } from '../screens/Login';

// E-poçt təsdiqi (KT-75).
// EmailVerifyLink — məktubdakı #verify=KOD linki: tətbiq açılanda bir dəfə göndərilir, nəticə yuxarıda bağ kimi görünür.
export function EmailVerifyLink() {
  const [state, setState] = useState<{ ok: boolean; text: string } | null>(null);
  useEffect(() => {
    const code = readLinkHash('verify');
    if (!code) return;
    api
      .verifyEmail(code)
      .then(() => setState({ ok: true, text: 'E-poçt təsdiqləndi. Parolu unutsanız, bərpa linki bu ünvana gələcək.' }))
      .catch((err: unknown) => setState({ ok: false, text: err instanceof ApiError ? err.message : 'Şəbəkə xətası. Linki yenidən açın.' }));
  }, []);
  if (!state) return null;
  return (
    <div className={`top-banner ${state.ok ? 'ok' : 'bad'}`} role="status">
      <span>{state.text}</span>
      <button type="button" className="banner-close" aria-label="Bağla" onClick={() => setState(null)}>
        ×
      </button>
    </div>
  );
}

// VerifyEmailNudge — ana səhifədə: e-poçt var, amma təsdiqlənməyib → «e-poçtunuzu təsdiqləyin».
export function VerifyEmailNudge() {
  const [need, setNeed] = useState<string | null>(null);
  const [msg, setMsg] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api
      .accountProfile()
      .then((p) => setNeed(p.email && !p.emailVerified ? p.email : null))
      .catch(() => setNeed(null));
  }, []);
  if (!need) return null;
  async function send() {
    setBusy(true);
    try {
      const r = await api.emailVerifySend();
      setMsg(r.sent ? `Təsdiq linki ${need} ünvanına göndərildi (24 saat keçərlidir).` : 'E-poçt artıq təsdiqlənib.');
    } catch (err) {
      setMsg(err instanceof ApiError ? err.message : 'Şəbəkə xətası. Yenidən cəhd edin.');
    } finally {
      setBusy(false);
    }
  }
  return (
    <div className="nudge" role="status">
      {msg ? (
        <span>{msg}</span>
      ) : (
        <>
          <span>E-poçtunuzu təsdiqləyin — parolu unutsanız, bərpa linki yalnız təsdiqli ünvana gedir.</span>
          <button type="button" className="btn-small" onClick={send} disabled={busy}>
            Təsdiq linki göndər
          </button>
        </>
      )}
    </div>
  );
}
